import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { ContactModel } from "./contactModel"

@Serializable
export class ContactUser extends ContactModel {
  uid: string = ""
  firstname: string = ""
  lastname: string = ""
  phone: string = ""

  constructor(
    data: {
      uid: string
      email: string
      firstname: string
      lastname: string
      name: string
      phone: string
      title: string
      spaceUserId: string
    } | null = null,
  ) {
    super(data)
    if (data) {
      this.uid = data.uid
      this.firstname = data.firstname
      this.lastname = data.lastname
      this.phone = data.phone
    }
  }
}
